import React from 'react';
import { Search, Filter } from 'lucide-react';
import { useTeamStore } from '../../stores/teamStore';
import { useLanguage } from '../../contexts/LanguageContext';

export const SearchFilters = () => {
  const { filters, setFilters, roles } = useTeamStore();
  const { translations } = useLanguage();

  return (
    <div className="bg-white p-4 rounded-lg shadow-sm space-y-4">
      <div className="flex flex-wrap gap-4">
        {/* Search Input */}
        <div className="flex-1 min-w-[200px]">
          <div className="relative">
            <input
              type="text"
              placeholder={translations?.team?.search?.placeholder || 'Search by name or email'}
              value={filters.search}
              onChange={(e) => setFilters({ search: e.target.value })}
              className="w-full pl-10 pr-4 py-2 border rounded-lg text-right
                       focus:ring-2 focus:ring-primary-500 transition-all"
            />
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={20} />
          </div>
        </div>

        {/* Role Filter */}
        <div className="w-48">
          <select
            value={filters.role}
            onChange={(e) => setFilters({ role: e.target.value })}
            className="w-full px-4 py-2 border rounded-lg text-right
                     focus:ring-2 focus:ring-primary-500 appearance-none"
          >
            <option value="">{translations?.team?.search?.filters?.allRoles || 'All Roles'}</option>
            {Object.values(roles).map((role) => (
              <option key={role.id} value={role.id}>
                {role.name}
              </option>
            ))}
          </select>
        </div>

        {/* Gender Filter */}
        <div className="w-48">
          <select
            value={filters.gender}
            onChange={(e) => setFilters({ gender: e.target.value })}
            className="w-full px-4 py-2 border rounded-lg text-right
                     focus:ring-2 focus:ring-primary-500 appearance-none"
          >
            <option value="">{translations?.team?.search?.filters?.allGenders || 'All Genders'}</option>
            <option value="male">{translations?.team?.search?.filters?.male || 'Male'}</option>
            <option value="female">{translations?.team?.search?.filters?.female || 'Female'}</option>
          </select>
        </div>

        {/* Status Filter */}
        <div className="w-48">
          <select
            value={filters.status}
            onChange={(e) => setFilters({ status: e.target.value })}
            className="w-full px-4 py-2 border rounded-lg text-right
                     focus:ring-2 focus:ring-primary-500 appearance-none"
          >
            <option value="">{translations?.team?.search?.filters?.allStatuses || 'All Statuses'}</option>
            <option value="active">{translations?.team?.search?.filters?.active || 'Active'}</option>
            <option value="suspended">{translations?.team?.search?.filters?.suspended || 'Suspended'}</option>
          </select>
        </div>
      </div>

      {/* Active Filters */}
      {Object.values(filters).some(Boolean) && (
        <div className="flex items-center gap-2">
          <Filter size={16} className="text-primary-500" />
          <span className="text-sm text-gray-600">
            {translations?.team?.search?.filters?.title || 'Active Filters'}:
          </span>
          <div className="flex gap-2">
            {filters.search && (
              <span className="text-xs bg-primary-50 text-primary-700 px-2 py-1 rounded">
                {translations?.team?.search?.filters?.search || 'Search'}: {filters.search}
              </span>
            )}
            {filters.role && (
              <span className="text-xs bg-primary-50 text-primary-700 px-2 py-1 rounded">
                {translations?.team?.search?.filters?.role || 'Role'}: {roles[filters.role]?.name}
              </span>
            )}
            {filters.gender && (
              <span className="text-xs bg-primary-50 text-primary-700 px-2 py-1 rounded">
                {translations?.team?.search?.filters?.gender || 'Gender'}:{' '}
                {filters.gender === 'male'
                  ? translations?.team?.search?.filters?.male || 'Male'
                  : translations?.team?.search?.filters?.female || 'Female'}
              </span>
            )}
            {filters.status && (
              <span className="text-xs bg-primary-50 text-primary-700 px-2 py-1 rounded">
                {translations?.team?.search?.filters?.status || 'Status'}:{' '}
                {filters.status === 'active'
                  ? translations?.team?.search?.filters?.active || 'Active'
                  : translations?.team?.search?.filters?.suspended || 'Suspended'}
              </span>
            )}
          </div>
          <button
            onClick={() => setFilters({ search: '', role: '', gender: '', status: '' })}
            className="text-sm text-red-500 hover:text-red-600"
          >
            {translations?.team?.search?.filters?.clearFilters || 'Clear Filters'}
          </button>
        </div>
      )}
    </div>
  );
};